import { UserRole } from '../types'

/**
 * 权限常量
 */
export const Permissions = {
  [UserRole.ADMIN]: ['*'], // 所有权限

  [UserRole.CUSTOMER]: [
    'order:create',
    'order:view:own',
    'order:update:own',
    'payment:pay',
    'certificate:download:own',
    'invoice:apply',
  ],

  [UserRole.MARKET]: [
    'order:view:all',
    'order:assign:cs',
    'exception:handle',
    'exception:view:all',
  ],

  [UserRole.SERVICE]: [
    'order:view:assigned',
    'order:assign:engineer',
    'order:update:status',
    'mail:confirm',
    'certificate:upload',
    'certificate:generate',
  ],

  [UserRole.ENGINEER]: [
    'task:view:own',
    'task:accept',
    'inspection:perform',
    'inspection:sign',
    'qrcode:generate',
  ],

  [UserRole.LAB_ENGINEER]: [
    'task:view:own',
    'task:accept',
    'inspection:perform',
    'qrcode:generate',
  ],

  [UserRole.FINANCE]: [
    'payment:view:all',
    'payment:audit',
    'payment:confirm',
    'invoice:view:all',
    'invoice:audit',
    'invoice:issue',
  ],

  [UserRole.MONTHLY_ADMIN]: [
    'payment:monthly:audit',
    'order:view:own',
    'order:view:company', // 查看公司所有订单
    'company:view:own', // 查看本公司信息
    'monthly:view:company', // 查看公司月结账单
  ],
} as const
